import React from "react";
import Pill from "../../Pill/pill";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getUserDetails, selectUser } from "../../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useFormattedAmount } from "../../../hooks/useFormattedAmount";

function RequesterInfo({ requester }) {
  return (
    <div className="flex flex-col">
      <span className="text-secondary !text-[#FFFFFF] !text-left">
        {requester.name || requester}
      </span>
      {/*{typeof requester === 'object' && requester.role && (
        <span className="text-secondary !text-left">{requester.role}</span>
      )}*/}
    </div>
  );
}

function TableCell({ item, value, className , formatFunction}) {
  if (item === "service") {
    return (
      <span className={`flex gap-[4px] items-center ${className}`}>
        {value}
      </span>
    );
  }

  if (item === "status") {
    let pillProps = { className: "!px-1.5 !py-1 !text-[12px]" };
    const normalized = value?.toLowerCase();
    
    if (normalized === "approved") {
      pillProps.greenFill = true;
    } else if (normalized === "rejected") {
      pillProps.redFill = true;
    } else if (normalized === "pending") {
      pillProps.yellowFill = true;
    }
    return (
      <span>
        <Pill {...pillProps}>
          {value}
        </Pill>
      </span>
    );
  }

  if (item === "requester") {
    return <RequesterInfo requester={value} />;
  }

  if (item === "cost") {
    return <span className={className}>{formatFunction(value)}</span>;
  }

  if (item === "date_needed") {
    return <span className={className}>{value}</span>;
  }

  return value;
}

function ApprovalTableBody({
  tableData,
  setState,
  setId,
  setPopup,
}) {
  const dispatch = useDispatch();
  const { userDetails } = useSelector(selectUser);
  const formatFunction = useFormattedAmount();

  return (
    <tbody>
      {tableData &&
        tableData.map((row, index) => (
          <tr
            key={index}
            className="hover:bg-[#363D50] hover:brightness-110 cursor-pointer"
            onClick={() => {
              setState(18);
              setId({ id: row.id, userId: row.requester?.id, approvalData: true });
              setPopup(true);
            }}
          >
            {Object.entries(row)
              .filter(([item]) => item !== "id")
              .map(([item, value], cellIndex) => (
                <td
                  key={cellIndex}
                  className="text-secondary !text-[#FFFFFF] py-[24px] px-[16px] min-w-[80px] md:min-w-[120px]"
                >
                  <TableCell
                    className={item === "service" ? "!font-medium" : ""}
                    item={item}
                    value={value}
                    formatFunction={formatFunction}
                  />
                </td>
              ))}
          </tr>
        ))}
      {!tableData && (
        <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
          {[1, 2, 3, 4, 5].map((el, index) => {
            return (
              <tr key={index}>
                <td className="px-3 py-4">
                  <Skeleton />
                </td>
                <td className="px-3 py-4">
                  <Skeleton />
                </td>
                <td className="px-3 py-4">
                  <Skeleton />
                </td>
                <td className="px-3 py-4">
                  <Skeleton />
                </td>
                <td className="px-3 py-4">
                  <Skeleton />
                </td>
              </tr>
            );
          })}
        </SkeletonTheme>
      )}
    </tbody>
  );
}

export default ApprovalTableBody;